"use client";

import { X } from "lucide-react";
import Link from "next/link";
import { useEffect, useState } from "react";

import { VisuallyHidden } from "@radix-ui/react-visually-hidden";

import { Button } from "~/components/ui/button";
import { Dialog, DialogContent, DialogTitle } from "~/components/ui/dialog";

interface NavigationItem {
  slug: string;
  shortTitle: string;
}

interface MobileNavigationProps {
  navigationItems: NavigationItem[];
  isOpen: boolean;
  onClose: () => void;
}

export function MobileNavigation({
  navigationItems,
  isOpen,
  onClose,
}: MobileNavigationProps) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) return null;

  const handleLinkClick = () => {
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="bg-mountain-clinic-blue data-[state=open]:slide-in-from-top-0 data-[state=closed]:slide-out-to-top-0 top-0 h-auto w-full max-w-full translate-y-0 rounded-none border-0 p-8">
        <VisuallyHidden>
          <DialogTitle>Navigation Menu</DialogTitle>
        </VisuallyHidden>

        <div className="mb-8 flex justify-start">
          <Button
            variant="ghost"
            size="icon"
            onClick={onClose}
            className="rounded-full border border-white [&_svg]:size-8"
          >
            <X className="h-12 w-12" />
          </Button>
        </div>

        <div className="flex flex-col items-end space-y-6">
          {navigationItems.map((item) => (
            <Link
              key={item.slug}
              href={`#${item.slug}`}
              onClick={handleLinkClick}
              className="hover:text-eurac-red rounded-full border-2 border-white px-6 py-2 text-lg font-medium text-white uppercase transition-colors hover:bg-white"
            >
              {item.shortTitle}
            </Link>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
